import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInstagram$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInstagram extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6c5693191bd4d64f777df426efffcfb53724ebb7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0fc34f90a83ff54e7c9774b480136b4e06aa0b91', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2e1b2842e16214019d7ed06450e2af785a19de77', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.973 3H7.666a5.8 5.8 0 0 0-1.948.364 4.15 4.15 0 0 0-2.354 2.354A5.8 5.8 0 0 0 3 7.666v6.614c.01.665.132 1.324.364 1.948a4.15 4.15 0 0 0 2.354 2.355 5.8 5.8 0 0 0 1.948.364c.33 0 .572.007.87.017.477.016 1.095.036 2.437.036 2.183 0 2.451 0 3.307-.053a5.8 5.8 0 0 0 1.948-.364 4.15 4.15 0 0 0 2.355-2.355 5.8 5.8 0 0 0 .364-1.948c0-.33.007-.572.017-.87A65 65 0 0 0 19 10.973c0-2.183 0-2.45-.053-3.307a5.8 5.8 0 0 0-.364-1.948 4.15 4.15 0 0 0-2.355-2.354A5.8 5.8 0 0 0 14.28 3zm0 1.445c2.14 0 2.397 0 3.21.053a4.5 4.5 0 0 1 1.489.268 2.6 2.6 0 0 1 1.53 1.53c.188.485.29 1 .3 1.52v6.421a4.4 4.4 0 0 1-.268 1.488 2.6 2.6 0 0 1-1.53 1.53c-.486.189-1 .29-1.52.3H7.763a4.4 4.4 0 0 1-1.488-.267 2.6 2.6 0 0 1-1.53-1.53c-.189-.486-.29-1-.3-1.52 0-.327-.008-.56-.018-.848a60 60 0 0 1-.036-2.363c0-2.14 0-2.398.054-3.211a4.5 4.5 0 0 1 .267-1.488c.257-.72.817-1.29 1.53-1.562a4.4 4.4 0 0 1 1.52-.268c.327 0 .56-.008.848-.017a59 59 0 0 1 2.363-.036m-4.12 6.582a4.12 4.12 0 1 1 8.24 0 4.12 4.12 0 0 1-8.24 0m4.12 2.675a2.676 2.676 0 1 1 0-5.35 2.676 2.676 0 0 1 0 5.35m4.281-5.993a.963.963 0 1 0 0-1.927.963.963 0 0 0 0 1.927", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-instagram", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-instagram"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-instagram":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInstagram$1);
            }
            break;
    } });
}

const CosmosIconInstagram = CosmosIconInstagram$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInstagram, defineCustomElement };
